import { FAMILY_HEADER } from './familyScope';

// Display name of the bride/groom family account that owns a record
export const ownerName = (owner) => {
  if (!owner) return '—';
  const p = owner.profile;
  return p?.firstName ? `${p.firstName} ${p.lastName || ''}`.trim() : owner.email;
};

// Mutation options that act for the family owning a record, so an admin viewing every
// family's records can edit/delete one without picking that family first
export const actAsOwner = (owner) => (owner ? { context: { headers: { [FAMILY_HEADER]: owner.id } } } : {});
